/* ============================================================
   sf-ros-quote.js
   Slide-out drawer controller: shared shell powering both the
   Cart drawer (data source: Shopify /cart.js) and the Quote
   drawer (data source: localStorage). Plus Add-to-Quote on PDPs.
   Built by Mark. Ship 1 of the Quote Request System.
   Vanilla JS, no dependencies. Cart-drawer logic is isolated so
   it can be feature-flagged off without touching the quote flow.
   ============================================================ */
(function () {
  'use strict';

  var QKEY = 'ros_quote_v1';
  var QUOTE_REQUEST_URL = '/pages/quote-request';
  var ENABLE_CART_DRAWER = true; // flip to false to fall back to native /cart

  /* ---------- Inline icons (Tabler is not loaded on storefront) ---------- */
  var ICON = {
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><path d="M12 3l7 4v5c0 4-3 6.5-7 8-4-1.5-7-4-7-8V7z"/><path d="M9 12l2 2 4-4"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>',
    quote: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="5" y="3.5" width="14" height="17" rx="2"/><rect x="9" y="2" width="6" height="3.2" rx="1" fill="currentColor" stroke="none"/><path d="M8.5 9.5h7M8.5 13h7M8.5 16.5h4.5" stroke-linecap="round"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" width="38" height="38"><path d="M6 7h12l1 13H5z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>',
    star: '<svg viewBox="0 0 24 24" fill="#89D84B" width="15" height="15" aria-hidden="true"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9.1l6.9-.8z"/></svg>'
  };

  /* ---------- Config per drawer ---------- */
  var CONFIG = {
    quote: {
      title: 'Your quote',
      subtotalLabel: 'Estimated subtotal',
      primaryLabel: 'Complete quote request',
      primaryHref: QUOTE_REQUEST_URL,
      support: ICON.shield + '<span>A simulator specialist reviews your quote and replies within <b>one business day</b>. No payment required to request.</span>',
      emptyText: 'Your quote is empty.',
      secondary: [
        { label: 'Convert to cart', act: 'quote-to-cart' },
        { label: 'Continue shopping', act: 'close' }
      ]
    },
    cart: {
      title: 'Your cart',
      subtotalLabel: 'Subtotal',
      primaryLabel: 'Secure Checkout',
      primaryHref: '/checkout',
      support: '',
      emptyText: 'Your cart is empty.',
      secondary: [
        { label: 'View cart', href: '/cart' },
        { label: 'Continue shopping', act: 'close' }
      ]
    }
  };

  /* ---------- Trust testimonial (mirrors the mobile-nav featured review) ---------- */
  function starsHtml(n) { var s = ''; for (var i = 0; i < n; i++) s += ICON.star; return s; }
  var TESTIMONIAL =
    '<div class="ros-drawer__testimonial">' +
      '<div class="ros-drawer__testi-stars">' + starsHtml(5) + '</div>' +
      '<p class="ros-drawer__testi-title">Great Selection. Best In Class Customer Service</p>' +
      '<p class="ros-drawer__testi-text">"These guys are the real deal. They have an incredible understanding of launch monitors and the nuances of that technology, and make a great hitting mat/enclosure as well. Second to none!"</p>' +
      '<p class="ros-drawer__testi-meta"><b>Anthony</b> &middot; Boston, MA &middot; 6 HCP</p>' +
      '<p class="ros-drawer__testi-product">Reviewing: Uneekor EyeXO2 SwingBay</p>' +
    '</div>';

  /* ---------- Money ---------- */
  function money(cents) {
    var d = cents / 100;
    var hasCents = Math.round(cents) % 100 !== 0;
    return '$' + d.toLocaleString('en-US', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  /* ---------- Quote store (localStorage) ---------- */
  function getQuote() {
    try {
      var raw = localStorage.getItem(QKEY);
      if (!raw) return { items: [] };
      var q = JSON.parse(raw);
      return q && Array.isArray(q.items) ? q : { items: [] };
    } catch (e) { return { items: [] }; }
  }
  function saveQuote(q) {
    try { localStorage.setItem(QKEY, JSON.stringify(q)); } catch (e) {}
    updateQuoteBubbles();
    document.dispatchEvent(new CustomEvent('ros:quote-changed'));
  }
  function quoteCount() {
    return getQuote().items.reduce(function (s, it) { return s + it.qty; }, 0);
  }
  function quoteSubtotal() {
    return getQuote().items.reduce(function (s, it) { return s + it.price * it.qty; }, 0);
  }
  function addToQuote(item) {
    var q = getQuote();
    var existing = q.items.filter(function (it) { return it.key === item.key; })[0];
    if (existing) { existing.qty += item.qty; }
    else { q.items.push(item); }
    q.updatedAt = new Date().toISOString();
    saveQuote(q);
  }
  function setQuoteQty(key, qty) {
    var q = getQuote();
    q.items.forEach(function (it) { if (it.key === key) it.qty = Math.max(1, qty); });
    saveQuote(q);
  }
  function removeQuoteItem(key) {
    var q = getQuote();
    q.items = q.items.filter(function (it) { return it.key !== key; });
    saveQuote(q);
  }

  /* ---------- Cart adapter (Shopify AJAX API) ---------- */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function cartAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }
  function cartChange(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- DOM refs ---------- */
  var overlay, drawers = {};
  function els() {
    overlay = document.querySelector('.ros-drawer-overlay');
    drawers.quote = document.querySelector('[data-ros-drawer="quote"]');
    drawers.cart = document.querySelector('[data-ros-drawer="cart"]');
  }

  /* ---------- Normalize line items to a common shape ---------- */
  function normQuoteItems() {
    return getQuote().items.map(function (it) {
      return {
        key: it.key,
        title: it.title,
        url: it.handle ? '/products/' + it.handle : '#',
        image: it.image || '',
        optionsText: (it.options || []).join(' · '),
        qty: it.qty,
        line: it.price * it.qty
      };
    });
  }
  function normCartItems(cart) {
    return cart.items.map(function (it) {
      var opts = (it.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return o.value; }).join(' · ');
      return {
        key: it.key,
        title: it.product_title,
        url: it.url,
        image: it.image || (it.featured_image && it.featured_image.url) || '',
        optionsText: opts,
        qty: it.quantity,
        line: it.line_price
      };
    });
  }

  /* ---------- Render ---------- */
  function thumbHtml(item) {
    if (item.image) {
      var src = item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_120x$1$2');
      return '<span class="ros-drawer__thumb"><img src="' + src + '" alt="" loading="lazy"></span>';
    }
    return '<span class="ros-drawer__thumb">' + ICON.quote + '</span>';
  }
  function itemHtml(which, item) {
    return '' +
      '<div class="ros-drawer__item">' +
        thumbHtml(item) +
        '<div class="ros-drawer__mid">' +
          '<a class="ros-drawer__item-title" href="' + item.url + '">' + item.title + '</a>' +
          (item.optionsText ? '<div class="ros-drawer__options">' + item.optionsText + '</div>' : '') +
        '</div>' +
        '<div class="ros-drawer__right">' +
          '<span class="ros-drawer__price">' + money(item.line) + '</span>' +
          '<div class="ros-stepper">' +
            '<button type="button" data-act="dec" data-key="' + item.key + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span class="ros-stepper__val">' + item.qty + '</span>' +
            '<button type="button" data-act="inc" data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="ros-drawer__remove" data-act="remove" data-key="' + item.key + '">Remove</button>' +
        '</div>' +
      '</div>';
  }
  function drawerHtml(which, items, subtotal) {
    var c = CONFIG[which];
    var count = items.reduce(function (s, it) { return s + it.qty; }, 0);
    var body, foot;
    if (!items.length) {
      var emptyCta;
      if (which === 'quote') {
        emptyCta = '<div style="display:flex;flex-direction:column;align-items:center;gap:12px;margin-top:6px;">' +
                     '<a class="ros-drawer__cta" href="' + QUOTE_REQUEST_URL + '" style="width:auto;padding:13px 30px;"><span>Request a Quote</span></a>' +
                     '<button type="button" data-act="close" style="width:auto;padding:11px 26px;background:#fff;border:1.5px solid #0B2856;border-radius:6px;color:#0B2856;font-weight:700;font-size:14px;cursor:pointer;">Continue shopping</button>' +
                   '</div>';
      } else {
        emptyCta = '<button type="button" class="ros-drawer__cta" data-act="close" style="width:auto;padding:13px 28px;">Continue shopping</button>';
      }
      body = '<div class="ros-drawer__empty">' + ICON.bag + '<p>' + c.emptyText + '</p>' + emptyCta + '</div>';
      foot = '';
    } else {
      body = '<div class="ros-drawer__body">' + items.map(function (it) { return itemHtml(which, it); }).join('') + '</div>' +
             (c.support ? '<div class="ros-drawer__support">' + c.support + '</div>' : '');
      var lockIco = (which === 'cart') ? ICON.lock : '';
      var primaryTag = c.primaryHref
        ? '<a class="ros-drawer__cta" href="' + c.primaryHref + '">' + lockIco + '<span>' + c.primaryLabel + '</span></a>'
        : '<button type="button" class="ros-drawer__cta">' + lockIco + '<span>' + c.primaryLabel + '</span></button>';
      var sec = c.secondary.map(function (s) {
        if (s.href) return '<a href="' + s.href + '">' + s.label + '</a>';
        return '<button type="button" data-act="' + s.act + '">' + s.label + '</button>';
      }).join('');
      var extraLines = '';
      if (which === 'cart') {
        extraLines = '<div class="ros-drawer__line"><span>Shipping</span><span class="ros-drawer__line-free">FREE Ground Shipping</span></div>' +
                     '<div class="ros-drawer__line"><span>Tax</span><span class="ros-drawer__line-muted">calculated at checkout</span></div>';
      } else if (which === 'quote') {
        extraLines = '<div class="ros-drawer__line"><span>Shipping &amp; Tax</span><span class="ros-drawer__line-muted">Calculated on quote</span></div>';
      }
      foot = '<div class="ros-drawer__foot">' +
               '<div class="ros-drawer__subtotal"><span class="ros-drawer__subtotal-label">' + c.subtotalLabel + '</span>' +
               '<span class="ros-drawer__subtotal-val">' + money(subtotal) + '</span></div>' +
               (which === 'cart' ? '<div class="ros-drawer__fin" data-ros-fin-cart style="min-height:20px;margin:2px 0 6px;font-size:14px;color:#0B2856;text-align:right"></div>' : '') +
               extraLines +
               primaryTag +
               '<div class="ros-drawer__sec">' + sec + '</div>' +
             '</div>';
    }
    var content = items.length
      ? '<div class="ros-drawer__scroll">' + body + foot + TESTIMONIAL + '</div>'
      : body;
    return '' +
      '<div class="ros-drawer__accent"></div>' +
      '<div class="ros-drawer__head">' +
        '<div class="ros-drawer__head-titles"><h2 class="ros-drawer__title">' + c.title + '</h2>' +
        (count ? '<span class="ros-drawer__count">' + count + (count === 1 ? ' item' : ' items') + '</span>' : '') + '</div>' +
        '<button type="button" class="ros-drawer__close" data-act="close" aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="ros-drawer__divider"></div>' +
      content;
  }
  function renderQuote() {
    if (!drawers.quote) return;
    drawers.quote.innerHTML = drawerHtml('quote', normQuoteItems(), quoteSubtotal());
  }
  /* Bread Pay "As low as $X/mo" under the cart subtotal (2026-10-17): one small JSON call, cached per amount. */
  var finCache = {};
  function cartFinancing(cents) {
    var el = drawers.cart && drawers.cart.querySelector('[data-ros-fin-cart]');
    if (!el || !window.fetch || !cents || cents < 5000) return;
    function show(d) { if (d && d.text) { el.textContent = 'As low as ' + d.text + '/mo with Bread Pay*'; el.title = d.note || ''; } }
    if (finCache[cents]) return show(finCache[cents]);
    fetch('https://api.platform.breadpayments.com/api/experience/servicing/as-low-as?merchantId=1afd4c5e-2f4e-4a34-b1a6-1f3b181b84cc&programId=2a1d717a-e4ea-43fc-9d2b-6844f06eda79&amount=' + cents)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var a = d && d.asLowAs; if (!a) return;
        var v = parseFloat(a.paymentAmount && a.paymentAmount.Value);
        finCache[cents] = { text: isFinite(v) ? '$' + (Math.ceil(v) / 100).toFixed(2) : (a.paymentAmountText && a.paymentAmountText['en-us']), note: a.promptText };
        show(finCache[cents]);
      }).catch(function () {});
  }
  function renderCart(cart) {
    if (!drawers.cart) return;
    drawers.cart.innerHTML = drawerHtml('cart', normCartItems(cart), cart.total_price);
    updateCartBubbles(cart);
    cartFinancing(cart.total_price);
  }

  /* ---------- Open / close ---------- */
  var lastFocus = null;
  function openDrawer(which) {
    if (!drawers[which]) return;
    if (which === 'quote') renderQuote();
    lastFocus = document.activeElement;
    Object.keys(drawers).forEach(function (k) { if (drawers[k]) drawers[k].classList.remove('is-open'); });
    drawers[which].classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawers[which].querySelector('.ros-drawer__close');
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    Object.keys(drawers).forEach(function (k) { if (drawers[k]) drawers[k].classList.remove('is-open'); });
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function openCart() {
    fetchCart().then(function (cart) { renderCart(cart); openDrawer('cart'); });
  }

  /* ---------- Header bubbles ---------- */
  function updateQuoteBubbles() {
    var n = quoteCount();
    document.querySelectorAll('[data-ros-quote-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[data-ros-quote-bubble]').forEach(function (el) {
      el.classList.toggle('td-hide', n === 0);
    });
  }
  function updateCartBubbles(cart) {
    var n = cart.item_count;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[data-cart-count-bubble]').forEach(function (el) {
      el.classList.toggle('td-hide', n === 0);
    });
  }

  /* ---------- Add-to-Quote (PDP) ---------- */
  function handleAddToQuote(btn) {
    var handle = btn.getAttribute('data-ros-quote-add');
    var form = btn.closest('form') || document.querySelector('form[action*="/cart/add"]');
    var variantId = null, qty = 1;
    if (form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput) variantId = idInput.value;
      var qtyInput = form.querySelector('[name="quantity"]');
      if (qtyInput && parseInt(qtyInput.value, 10) > 0) qty = parseInt(qtyInput.value, 10);
    }
    btn.classList.add('is-loading');
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variant = null;
        if (variantId) {
          variant = product.variants.filter(function (v) { return String(v.id) === String(variantId); })[0];
        }
        if (!variant) variant = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
        var opts = (variant.options || []).filter(function (o) { return o && o !== 'Default Title'; });
        var img = variant.featured_image ? variant.featured_image.src : (product.featured_image || (product.images && product.images[0]) || '');
        addToQuote({
          key: String(variant.id),
          variantId: variant.id,
          productId: product.id,
          handle: product.handle,
          title: product.title,
          variantTitle: variant.title,
          options: opts,
          image: img,
          price: variant.price,
          qty: qty
        });
        openDrawer('quote');
      })
      .catch(function () {})
      .then(function () { btn.classList.remove('is-loading'); });
  }

  /* ---------- Quote -> cart (bulk convert) ---------- */
  function quoteToCart() {
    var items = getQuote().items.map(function (it) { return { id: it.variantId, quantity: it.qty }; });
    if (!items.length) return;
    cartAdd(items).then(function () {
      saveQuote({ items: [] });
      return fetchCart();
    }).then(function (cart) { renderCart(cart); openDrawer('cart'); });
  }

  /* ---------- Delegated drawer actions ---------- */
  function onDrawerClick(which, e) {
    var t = e.target.closest('[data-act]');
    if (!t) return;
    var act = t.getAttribute('data-act');
    var key = t.getAttribute('data-key');
    if (act === 'close') { e.preventDefault(); closeDrawer(); return; }
    if (act === 'quote-to-cart') { e.preventDefault(); quoteToCart(); return; }
    if (which === 'quote') {
      var qi = getQuote().items.filter(function (it) { return it.key === key; })[0];
      if (act === 'inc' && qi) setQuoteQty(key, qi.qty + 1), renderQuote();
      else if (act === 'dec' && qi) setQuoteQty(key, qi.qty - 1), renderQuote();
      else if (act === 'remove') removeQuoteItem(key), renderQuote();
    } else if (which === 'cart') {
      if (act === 'inc' || act === 'dec' || act === 'remove') {
        var row = t.closest('.ros-drawer__item');
        var curr = row ? parseInt(row.querySelector('.ros-stepper__val').textContent, 10) : 1;
        var next = act === 'remove' ? 0 : (act === 'inc' ? curr + 1 : Math.max(1, curr - 1));
        cartChange(key, next).then(function (cart) { renderCart(cart); });
      }
    }
  }

  /* ---------- Product-form intercept (cart drawer) ---------- */
  function interceptCartForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (form.classList.contains('ajax-product-form')) return; // theme already AJAXes these
      if (form.hasAttribute('data-ros-upsell-managed')) return; // owned by the PDP upsell controller (sf-ros.js)
      e.preventDefault();
      e.stopImmediatePropagation();
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function () { return fetchCart(); })
        .then(function (cart) { renderCart(cart); openDrawer('cart'); })
        .catch(function () { form.submit(); }); // fallback to native if AJAX fails
    }, true); // capture phase: runs before any theme handler
  }

  /* ---------- Wire ---------- */
  function wire() {
    els();
    if (!overlay) return;
    overlay.addEventListener('click', closeDrawer);
    if (drawers.quote) drawers.quote.addEventListener('click', function (e) { onDrawerClick('quote', e); });
    if (drawers.cart) drawers.cart.addEventListener('click', function (e) { onDrawerClick('cart', e); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    document.addEventListener('click', function (e) {
      var atq = e.target.closest('[data-ros-quote-add]');
      if (atq) { e.preventDefault(); handleAddToQuote(atq); return; }
      var qt = e.target.closest('[data-ros-quote-toggle]');
      if (qt) { e.preventDefault(); openDrawer('quote'); return; }
      var ct = e.target.closest('[data-ros-cart-toggle]');
      if (ct && ENABLE_CART_DRAWER) { e.preventDefault(); openCart(); return; }
    });

    if (ENABLE_CART_DRAWER) interceptCartForms();
    updateQuoteBubbles();
    fetchCart().then(function (cart) { updateCartBubbles(cart); }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else { wire(); }

  /* Expose API for the quote-request page summary + debugging */
  window.RosQuote = {
    open: openDrawer, close: closeDrawer, openCart: openCart,
    get: getQuote, setQty: setQuoteQty, remove: removeQuoteItem,
    subtotal: quoteSubtotal, count: quoteCount, money: money,
    toCart: quoteToCart,
    clear: function () { saveQuote({ items: [] }); }
  };
})();

